import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import store from 'redux/store';

export const reqTransform = {
  fetchStoragePlan(params) {
    let bodyParams = {
      ...params,
    };
    return bodyParams;
  },
};

export const resTransform = {
  fetchStoragePlan(resData) {
    // console.log('ResData', resData);
    let storageData = (_.isArray(resData) ? resData : []).map((details) => {
      return resTransform.fetchStoragePlanDetails(details);
    });
    // Create unique key using combination of transfer_date and storage_plan_master_id
    return _.keyBy(storageData, (item) => `${item.transfer_date}_${item.storage_plan_master_id}`);
  },
  fetchStoragePlanDetails(resData) {
    return {
      ...resData,
      // Generate unique id using combination of transfer_date and storage_plan_master_id
      id: `${_.get(resData, 'transfer_date') || ''}_${_.get(resData, 'storage_plan_master_id') || ''}`,
    };
  },
};

// export const resTransform = {
//     fetchStoragePlan(resData) {
//       let storageData = (_.isArray(resData) ? resData : []).map((details) => {
//         return resTransform.fetchStoragePlanDetails(details);
//       });
//       // Sort by Transfer_Date in descending order (most recent first)
//       return _.orderBy(storageData, (o) => new Date(o.transfer_date), ['desc']);
//     },

//     fetchStoragePlanDetails(resData) {
//       return {
//         ...resData,
//         id: _.get(resData, 'sched_stock_in_out_id') || '',
//       };
//     },
//   };
